import Link from '@tiptap/extension-link';

export const CustomLink = Link.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: null,
      },
    };
  },
  addPasteRules() {
    return [
      {
        find: /^(https?:\/\/[^\s]+|www\.[^\s]+)$/g,
        handler: ({ match, chain, state, range }) => {
          let url = match[1];
          if (url.startsWith('www.')) {
            url = `https://${url}`;
          }
          const { empty } = state.selection;

          if (empty) {
            // If no text is selected, use the URL as both the link text and href
            chain()
              .focus()
              .deleteRange(range)
              .insertContent({
                type: 'text',
                text: url,
                marks: [
                  {
                    type: 'link',
                    attrs: { href: url },
                  },
                ],
              })
              .run();
          } else {
            // If text is selected, use it as the link text
            chain().setMark('link', { href: url }).run();
          }
        },
      },
    ];
  },
  inclusive: false,
}).configure({
  openOnClick: false,
  autolink: true,
  linkOnPaste: true,
});
